import { Icon } from '@components/primitives';
import colors from '@theme/colors';
import React from 'react';

const ArrowUp: React.FC = () => <Icon name="up" family="antdesign" color={colors.neutral.charcoal} />;

export default ArrowUp;
